module.exports = __webpack_public_path__ + "static/media/documentation.e889cedc.png";